import type { BoardItemListItemResponse } from "@/client";
import type {
	VideoEvidence,
	VideoEvidenceInfluencer,
} from "~/modules/shared/chat/ChatEventTypes";

export function mapBoardClipsToVideoEvidence(
	clips: BoardItemListItemResponse[] | undefined,
): VideoEvidence[] | undefined {
	if (clips == null) {
		return undefined;
	}
	return clips.map((clip) => {
		const start = clip.clipped_start ?? clip.start ?? 0;
		const end = clip.clipped_end ?? clip.end ?? 0;
		const clipDuration = end - start;
		const sourceDuration =
			clip.video?.duration_seconds ?? (clip.end ?? 0) - (clip.start ?? 0);
		return {
			thumbnail_url:
				clip.assets.find((asset) => asset.type === "thumbnail")?.signed_url ??
				"",
			video_url:
				clip.assets.find((asset) => asset.type === "preview_mp4")?.signed_url ??
				"",
			aspect_ratio: clip.aspect_ratio,
			start_time: start - (clip.start ?? 0),
			end_time: end - (clip.start ?? 0),
			video_duration: sourceDuration,
			clip_duration: clipDuration,
			source_start_time: start,
			description: "",
			title: clip.video?.title ?? null,
			video_id: clip.id,
			influencer: clip.influencer as VideoEvidenceInfluencer,
			social_account: {
				...clip.social_account,
				follower_count: clip.social_account?.follower_count ?? 0,
				handle: clip.social_account?.handle ?? "",
				platform: clip.social_account?.platform ?? "",
				profile_picture_url: clip.social_account?.profile_picture_url ?? "",
				profile_url: clip.social_account?.profile_url ?? "",
			},
			post_url: clip.post_url,
			view_count: clip.video?.views ?? null,
		};
	});
}
